'use strict';

/**
 * @module GeoSearch
 * @author Philip & Micha
 */

const BaseView = require('./_');
const GeoSearchTemplate = require('../../templates/geosearch.html');
const TemplateHelper = require('../helpers/template');
const $ = require('zepto');
const ConfigurationHelper = require('../helpers/configuration');
const EventHelper = require('../helpers/event');

class GeoSearch extends BaseView {
	constructor (parent) {
		super({
			parent
		});
	}

	render () {
		TemplateHelper.render({
			view: this,
			template: GeoSearchTemplate,
			data: {}
		});
		
		// set input to deal with
		const $input = this.$el.find('input');
		const input = $input[0];
		
		this.patchInputFirstElementTrick(input);
		
		const autoComplete = new google.maps.places.Autocomplete(input, {
			componentRestrictions: {
				country: ConfigurationHelper.getAutoCompletionCountries()
			}
		});

		autoComplete.addListener('place_changed', () => {
			const place = autoComplete.getPlace();

			if (!place.geometry) {
				$input.addClass('field__input--error');
				return;
			}

			EventHelper.geometry(place.geometry);
			$input.blur();
			setTimeout(() => {
				$input.val('').blur();
			}, 300);
		});
	}
	
	locate () {
		const $button = this.$el.find('.geosearch__button');
		if (!navigator.geolocation) {
			$button.addClass('geosearch__button--disabled');
			return;
		}
		
		navigator.geolocation.getCurrentPosition(
			(pos) => { // success
				EventHelper.geometry({
					location: new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude),
					zoom: parseInt(Math.log2(591657550.5 / (Math.max(pos.coords.accuracy, 1) * 45))) - 2
				});
			},
			() => { // error
				$button.addClass('geosearch__button--error');
			}
		);
		
		$button.blur();
	}
	
	patchInputFirstElementTrick (input) {
		const _addEventListener = input.addEventListener;
		input.addEventListener = (type, listener) => {

			// Simulate a 'down arrow' keypress on hitting 'return' when no POI suggestion is selected, and then
			// trigger the original listener.
			if (type === 'keydown') {
				const origListener = listener;
				listener = event => {
					const suggestionSelected = $('.pac-item-selected').length > 0;
					if (event.which === 13 && !suggestionSelected) {
						const simulatedDownarrow = $.Event('keydown', {keyCode: 40, which: 40});
						origListener.apply(input, [simulatedDownarrow]);
					}

					origListener.apply(input, [event]);
				};
			}

			// add the modified listener
			_addEventListener.apply(input, [type, listener]);
		};
	}
}

module.exports = GeoSearch;
